export default "__VITE_ASSET__EoZNetBQ__"